import React, { useEffect, useMemo, useState } from 'react';
import { MaterialReactTable } from 'material-react-table';
import { Link } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.css';

import GuestsDetailsModal from '../../components/common/guestDetailsModal';
import DeleteGuestModal from 'src/components/common/delete-guest-modal';

import { useQuery } from 'react-query';
import useAxios from '../../sections/useAxios';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { BsTrashFill } from 'react-icons/bs';




const GuestListing = () => {
  document.title = 'Guests Listing | SNB Offsite';
  
  let api = useAxios()

  const [activeGuest, setActiveGuest] = useState(false)
  const [isModalOpen, setModalOpen] = useState(false);
  const [deleteGuest, setDeleteGuest] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)


  const toggleEditModal = () => {
    if (isModalOpen){
      setActiveGuest(false)
    }
    setModalOpen(!isModalOpen);
  };


  const toggleDeleteModal = () => {
    if (deleteModal){
      setDeleteGuest(false)
    }
    setDeleteModal(!deleteModal);
  };

  const {
    isLoading,
    isError,
    data,
    isSuccess,
    refetch
} = useQuery(`guestListing`, async () => api.get(`/guests/list`), {
  cacheTime: 0
})

useEffect(() => {
    if (activeGuest){
      toggleEditModal()
    }
}, [activeGuest])


const columnsRequired = useMemo(
    () => [
      {
        accessorKey: 'title',
        header: 'Title',
        size: 100,
      },
      {
        accessorKey: 'first_name',
        header: 'First Name',
        size: 50,
      },
      {
        accessorKey: 'last_name',
        header: 'Last Name',
        size: 50,
      },
      {
        accessorKey: 'room_number',
        header: 'Room No.',
        size: 50,
      },

      {
        header: 'View Details',
        Cell: ({ row }) => (
          <button onClick={() => setActiveGuest(row.original.id)} className='btn admin-green-btn'>
            Details
          </button>
        )
      },
      {
        header: 'Delete',
        Cell: ({ row }) => (

            <BsTrashFill
              onClick={() => setDeleteGuest({'name' : `${row?.original?.title} ${row?.original?.first_name} ${row?.original?.last_name}`, 'id': row.original.id})}
              style={{ cursor: 'pointer' }}
          />

        )
      }
    
    ],
    []
  );

  const guests = data?.data ?? []

  const handleResponse = (status, response) => {
    if (status === 'success'){
      if (response.status === 200){
        toast.success('Guest Information Updated!')
        toggleEditModal()
      }
      if (response.status === 204){
        toast.success('Guest Deleted!')
        toggleDeleteModal()
      }
      refetch()
    }
    else{
      if (response?.response?.status === 400){
        if (response?.response?.data){
          toast.error(response?.response?.data)
        }
        else{

          toast.error('Something went wrong')
        }
      }
      else{
        toast.error('Something went wrong')  
      }
    }
  }


  useEffect(() => {
      if (deleteGuest){
        setDeleteModal(true)
      }
  }, [deleteGuest])

  return (
    <>
      <div
        className="container-fluid breadcrumb-color d-flex align-items-center mb-3"  id='breadCrumbStyling'>
        <nav aria-label="breadcrumb" className="d-flex align-items-center">
          <ol className="breadcrumb">
            <li
              className="breadcrumb-item text-white text-center active fs-4 pt-3 ps-2"
              aria-current="page"
              id='breadCrumbTitleStyling'
            >
              Guests Listing
            </li>
          </ol>
        </nav>
      </div>


        <div className="container-fluid p-4" id='formStyling'>

          <MaterialReactTable
            columns={columnsRequired}
            data={guests}
            muiTablePaperProps={{
              elevation: 0,
            }}
            state={{isLoading: isLoading}}
          />

            <GuestsDetailsModal
              isOpen={isModalOpen}
              toggle={toggleEditModal}
              guestID={activeGuest}
              handleResponse={handleResponse}
            />
            <DeleteGuestModal
              isOpen={deleteModal}
              toggle={toggleDeleteModal}
              guest={deleteGuest}
              handleResponse={handleResponse}
            />

{/*  */}

        </div>
    </>
  );
};

export default GuestListing;









